import React, {createContext} from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import {Provider} from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import wordsReducer from './reducers/words-reducer';
import gameModeReducer from './reducers/game-mode-reducer';
import usedLettersReducer from './reducers/used-letters-reducer';
import collectedLettersReducer from './reducers/collected-letters-reducer';
import pendingConfirmationReducer from './reducers/pending-confirmation-reducer';
import App from './App';
import WordSearchGameState from './mobx/WordSearchGameState';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const gameReducers = combineReducers({
    words: wordsReducer,
    gameMode: gameModeReducer,
    usedLetters: usedLettersReducer,
    collectedLetters: collectedLettersReducer,
    pendingConfirmation: pendingConfirmationReducer,
});

const gameStore = createStore(gameReducers, composeEnhancers(applyMiddleware(thunkMiddleware)));

const rootElement = document.getElementById('root');
const render = () => {
    ReactDOM.render(
        <Provider store={gameStore}>
            <App />
        </Provider>,
        rootElement || document.createElement('div')
    );
};

render();
